import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AlertColor,
  Direction,
  ToastSize,
  AlertVariant,
} from '../../types/ToastTypes';

export interface ToastItem {
  id: string;
  message: string;
  type: AlertColor;
  direction: Direction;
  size: ToastSize;
  variant: AlertVariant;
}

export interface ToastState {
  /** Active toasts, oldest first. Rendered as a stack. */
  toasts: ToastItem[];
}

const initialState: ToastState = {
  toasts: [],
};

// Cap the visible stack so a burst (e.g. many duplicate-file errors) can't
// fill the screen; the oldest toasts drop off once the limit is reached.
const MAX_TOASTS = 5;

type ShowToastPayload = {
  id: string;
  message: string;
  type?: AlertColor;
  direction?: Direction;
  size?: ToastSize;
  variant?: AlertVariant;
};

const toasterSlice = createSlice({
  name: 'toaster',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<ShowToastPayload>) => {
      state.toasts.push({
        id: action.payload.id,
        message: action.payload.message,
        type: action.payload.type || 'primary',
        direction: action.payload.direction || 'top-right',
        size: action.payload.size || 'md',
        variant: action.payload.variant || 'soft',
      });
      if (state.toasts.length > MAX_TOASTS) {
        state.toasts.splice(0, state.toasts.length - MAX_TOASTS);
      }
    },
    hideToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter(
        (toast) => toast.id !== action.payload
      );
    },
    clearToasts: (state) => {
      state.toasts = [];
    },
  },
});

export const { showToast, hideToast, clearToasts } = toasterSlice.actions;

export const toastReducer = toasterSlice.reducer;
